import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Flex,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TableFallback from '../../Components/Loader/TableFallback';
import { useGetTemplatesQuery, useNewTemplateMutation } from '../../Services/templates';
import TemplateRow from './TemplateRow';
import DeleteTemplateModal from '../../Components/DeleteFormModal/DeleteTemplateModal';

export const TempalteListLoader = () => async () => ({ name: 'Templates' });

const TemplatesListPage = () => {
  const textColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const rta = useGetTemplatesQuery();
  const [newTemplate, { isLoading }] = useNewTemplateMutation();
  const navigate = useNavigate();
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [formDelete, setFormDelete] = useState();

  const handleNewTemplate = async () => {
    const { data } = await newTemplate();
    console.log(data);
    if (data.status === 'ok') {
      navigate(`/templates/${data.template.id}/edit?tab=setup&a=main`);
    } else if (data.type === 'MAX_TEMPLATES') {
      toast({
        title: 'Max templates reached',
        description: "You can't create new templates. Please upgrade your plan or delete one of the existing templates",
        status: 'warning',
        variant: 'left-accent',
        isClosable: true,
        position: 'top',
        duration: 10000,
      });
    }
  };

  const openDeleteFormModal = (form) => {
    setFormDelete(form);
    onOpen();
  };

  return (
    <Flex direction="column">
      <Card
        my="22px"
        overflowX={{ sm: 'scroll', xl: 'hidden' }}
        pb="0px"
      >
        <CardHeader>
          <Flex direction="row" justify="space-between">
            <Text fontSize="lg" color={textColor} fontWeight="bold">
              Templates
            </Text>
            <Button size="sm" colorScheme="blue" onClick={handleNewTemplate} isLoading={isLoading}>New template</Button>
          </Flex>
        </CardHeader>
        <CardBody>
          <Table color={textColor}>
            <Thead>
              <Tr>
                <Th borderColor={borderColor} w="70%">
                  Template Name
                </Th>
                <Th borderColor={borderColor}>Uses</Th>
                <Th borderColor={borderColor} />
              </Tr>
            </Thead>
            <Tbody>
              {rta.isFetching ? <TableFallback cols={2} />
                : rta.data.map((row, r) => (
                  <TemplateRow row={row} key={r} onDelete={openDeleteFormModal} />
                ))}
            </Tbody>
          </Table>
          <DeleteTemplateModal isOpen={isOpen} onClose={onClose} form={formDelete} />
        </CardBody>
      </Card>
    </Flex>
  );
};

export default TemplatesListPage;
